import React, { useEffect, useState } from "react";
import axios from "axios";
import AdminLayout from "./adminLayout";

const API_URL = process.env.REACT_APP_API_URL;

const AdminRentalRequests = () => {
  const [requests, setRequests] = useState([]);
  const [statusUpdates, setStatusUpdates] = useState({}); // rentalId: status

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_URL}/api/rentals/getallrequest`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRequests(res.data);
    } catch (err) {
      console.error("Failed to fetch rental requests", err);
    }
  };

  const handleStatusChange = (rentalId, status) => {
    setStatusUpdates((prev) => ({ ...prev, [rentalId]: status }));
  };

  const submitGroupStatus = async (groupId) => {
    const token = localStorage.getItem("token");

    const groupUpdates = requests
      .filter((r) => r.groupId === groupId && statusUpdates[r.id])
      .map((r) => ({
        rentalId: r.id,
        status: statusUpdates[r.id],
      }));

    if (groupUpdates.length === 0)
      return alert("No changes to submit for this group");

    try {
      await axios.put(
        `${API_URL}/api/rentals/group/status`,
        {
          groupId,
          updates: groupUpdates,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      alert("Statuses updated successfully");
      setStatusUpdates({});
      fetchRequests();
    } catch (err) {
      console.error("Failed to update statuses", err);
      alert("Failed to update statuses");
    }
  };

  const grouped = requests.reduce((acc, r) => {
    acc[r.groupId] = acc[r.groupId] || [];
    acc[r.groupId].push(r);
    return acc;
  }, {});

  return (
    <AdminLayout>
      <div className="p-6">
        {Object.entries(grouped).map(([groupId, rentals]) => (
          <div key={groupId} className="border mb-6 p-4 rounded shadow">
            <h3 className="text-xl font-semibold mb-2">Group ID: {groupId}</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {rentals.map((r) => (
  <div key={r.id} className="border p-3 rounded bg-gray-50">
    <img
      src={r.plantImageUrl?.startsWith("http") ? r.plantImageUrl : `${API_URL}${r.plantImageUrl}`}
      alt={r.plantName}
      className="w-full h-32 object-cover rounded mb-2"
    />
    <p><strong>Plant ID:</strong> {r.plantId}</p>
    <p><strong>Title:</strong> {r.plantName}</p>
    <p><strong>User:</strong> {r.fullName} ({r.email})</p>
    <p><strong>Start:</strong> {r.rentalStartDate}</p>
    <p><strong>End:</strong> {r.rentalEndDate}</p>
    <p><strong>Days:</strong> {r.rentalDays}</p>
    <p><strong>Status:</strong> {r.status}</p>

    <div className="mt-2 space-x-2">
      <button
        onClick={() => handleStatusChange(r.id, "ACCEPTED")}
        className="px-3 py-1 bg-green-600 text-white rounded"
      >
        Accept
      </button>
      <button
        onClick={() => handleStatusChange(r.id, "REJECTED")}
        className="px-3 py-1 bg-red-600 text-white rounded"
      >
        Reject
      </button>
    </div>
  </div>
))}
            </div>
            <div className="mt-4 text-right">
              <button
                onClick={() => submitGroupStatus(groupId)}
                className="bg-blue-600 text-white px-4 py-2 rounded"
              >
                Submit Changes for Group
              </button>
            </div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
};

export default AdminRentalRequests;
